export default __webpack_public_path__ + "static/media/leather_모바일.c7050a36.jpg";